/* ==========================================================================
   crate-parent.js — full-crate hearth page
   --------------------------------------------------------------------------
   Deliberately much smaller than hearth-parent.js. No cutting, no guillotine
   packing test, no service add-ons, no paired cart lines. A crate is one line
   item; the only arithmetic that matters is price-per-slab and which of the
   four fulfilment routes the buyer picks.

   FOUR ROUTES, and they are not the same as the single-slab page's three:
     deliver  — free on full crates, England & Wales
     express  — the crate express rate, £24 standard / £48 oversized
     collectC — Colchester, where the crates actually are. Free, book in.
     collectM — Milton Keynes. Free, but the crate has to be moved there first,
                which is the same 2-3 working day transfer the single-slab page
                models in the opposite direction.

   SOLD-OUT GATE — added 12 Sep 2026, ported from hearth-parent.js.
   This page already refused the SALE when stock ran short: `ready` tested
   `stock >= q`, so the button did disable at zero. What it did not do was stop
   the page TALKING as though the crate were coming. A sold-out crate still
   printed "Ready to collect Thursday 17 September" directly under a dead
   button, and the dropdowns gave no warning until you picked the gone size.

   The gate now reads `variant.available` — Shopify's own verdict — and never a
   quantity. Quantity cannot tell you the inventory policy: a CONTINUE line at
   zero is still sellable, and gating on the number would refuse stock we are
   happy to backorder. `available` is true on CONTINUE at any quantity and
   false only on DENY at zero, which is exactly the distinction this page needs.
   `stock` is still used, separately, for "we hold fewer than you asked for".
   ========================================================================== */
(function () {
  var root = document.getElementById('cp-root');
  if (!root) return;

  function $(id) { return document.getElementById(id); }
  function readJSON(id) {
    var el = $(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  var cfg = readJSON('cp-config');
  var variants = readJSON('cp-variants');
  var meta = readJSON('cp-meta');
  if (!cfg || !variants || !meta) return;

  var sizeSel = $('cp-opt-0'), thkSel = $('cp-opt-1'), gradeSel = $('cp-opt-2'), delSel = $('cp-del');
  var state = { del: 'deliver' };

  /* ---- sold-out gate ---------------------------------------------------- */
  /* Null-safe and strictly === false, so a variant object that predates the
     Liquid change (no `available` key at all) is treated as buyable rather than
     silently blanking the page. */
  function soldOutFor(v) { return !!v && v.available === false; }

  /* These four strings are deliberately NOT defined in crate-parent.liquid, so
     the fallbacks below are what actually renders. Same choice as the single-
     slab page: it keeps this deploy to two files. If they ever need to be
     editable from the customiser, add them to the section's `copy` block. */
  function say(key, fallback) { return (cfg.copy && cfg.copy[key]) ? cfg.copy[key] : fallback; }
  function soldOutBtnLabel() { return say('atcSoldOut', 'Sold out'); }
  function soldOutBadge() { return say('stockOut', 'Out of stock — more on the next container'); }
  function soldOutSuffix() { return say('selectSoldOut', 'sold out'); }
  /* Says nothing about what else is in stock. The single-slab page asserts
     "every other size is in stock", which is true there today and may not be
     here tomorrow — three honed crates sit at three each. */
  function soldOutNote() {
    return say('soldOutNote', 'This crate is sold out. Call 01908 46 46 56 and we will book you onto the next container.');
  }

  /* The line MUST be created inside #cp-form. crate-parent.css gives every
     child of .cp__info an explicit order under 749px and catches strays with
     `.cp__info > * { order: 15 }` — a paragraph appended there sinks below the
     specs table, miles from the button it explains. Inside the form it rides
     the form's own order: 10 and stays welded to the button. Borrows .cp__note
     so no CSS ships. */
  function soldOutLine() {
    var el = $('cp-soldout');
    if (el) return el;
    var form = $('cp-form');
    if (!form) return null;
    el = document.createElement('p');
    el.id = 'cp-soldout';
    el.className = 'cp__note';
    el.style.color = '#9a1c1c';
    el.hidden = true;
    var btn = $('cp-atc');
    if (btn && btn.parentNode === form) form.insertBefore(el, btn);
    else form.appendChild(el);
    return el;
  }

  function money(pence) {
    return '£' + (pence / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function chosen() {
    return [
      sizeSel ? sizeSel.value : null,
      thkSel ? thkSel.value : null,
      gradeSel ? gradeSel.value : null
    ];
  }
  function findVariant(vals) {
    for (var i = 0; i < variants.length; i++) {
      var o = variants[i].options;
      if (String(o[0]) === String(vals[0]) && String(o[1]) === String(vals[1]) && String(o[2]) === String(vals[2])) {
        return variants[i];
      }
    }
    return null;
  }
  function currentVariant() { return findVariant(chosen()); }

  /* Slabs per crate is not derivable from anything — a 900x600 crate holds 30
     and a 1500x900x30mm holds 10. It comes from a theme setting keyed by
     "size|thickness" so the yard can change it without touching code. */
  function slabsFor(v) {
    if (!v) return null;
    var key = v.options[0] + '|' + v.options[1];
    return typeof meta.slabs[key] === 'number' ? meta.slabs[key] : null;
  }
  function bandFor(v) {
    return (v && meta.bands[v.id] === 'oversized') ? 'oversized' : 'standard';
  }
  function stockFor(v) {
    return (v && typeof meta.qty[v.id] === 'number') ? meta.qty[v.id] : null;
  }

  /* ---- working-day arithmetic, same rules as the single-slab page ---- */
  function addWorkingDays(n) {
    var d = new Date(); d.setHours(0, 0, 0, 0);
    var added = 0, guard = 0;
    while (added < n && guard < 400) {
      guard++; d.setDate(d.getDate() + 1);
      var dow = d.getDay();
      if (dow === 0 || dow === 6) continue;
      var iso = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
      if (cfg.bankHolidays.indexOf(iso) >= 0) continue;
      added++;
    }
    return d;
  }
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MON = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  function longDate(d) { return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MON[d.getMonth()]; }
  function shortDate(d) { return DAYS[d.getDay()].slice(0, 3) + ' ' + d.getDate() + ' ' + MON[d.getMonth()].slice(0, 3); }

  function freight(v, mode) {
    if (!v) return null;
    if (mode === 'collectC' || mode === 'collectM') return 0;
    if (mode === 'express') return bandFor(v) === 'oversized' ? cfg.crateExpressOversized : cfg.crateExpressStandard;
    return cfg.crateEconomy;
  }
  function isDelivery(mode) { return mode === 'deliver' || mode === 'express'; }

  function qty() {
    var el = $('cp-qty');
    return Math.max(1, parseInt(el ? el.value : '1', 10) || 1);
  }

  /* Unavailable combinations are real gaps, not oversights — there is no
     Premium crate at 900x600 or 900x900. Label them rather than hide them, so
     the shape of the range stays legible.

     A SOLD-OUT option is a different thing from one that does not exist, and it
     stays SELECTABLE. Merchant Center sends traffic to a specific ?variant= and
     that buyer has to be able to see the exact crate the ad showed them;
     disabling the option would swap the crate and the price underneath them.
     The suffix carries the warning, the button refuses the sale. */
  function renderSelect(sel, idx) {
    if (!sel) return;
    var vals = chosen();
    for (var i = 0; i < sel.options.length; i++) {
      var opt = sel.options[i];
      var probe = vals.slice();
      probe[idx] = opt.value;
      var hit = findVariant(probe);
      var label = opt.value;
      if (!hit) label += '   — ' + cfg.copy.unavailable;
      else if (soldOutFor(hit)) label += '   — ' + soldOutSuffix();
      if (opt.textContent !== label) opt.textContent = label;
      opt.disabled = false;
    }
  }

  /* If the current three selections have no variant, walk to the nearest one
     that does rather than leaving the page in a dead state. */
  function repair() {
    if (currentVariant()) return;
    var vals = chosen();
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].options[0]) === String(vals[0])) {
        if (thkSel) thkSel.value = variants[i].options[1];
        if (gradeSel) gradeSel.value = variants[i].options[2];
        return;
      }
    }
    if (variants[0]) {
      if (sizeSel) sizeSel.value = variants[0].options[0];
      if (thkSel) thkSel.value = variants[0].options[1];
      if (gradeSel) gradeSel.value = variants[0].options[2];
    }
  }

  function render() {
    repair();
    renderSelect(sizeSel, 0);
    renderSelect(thkSel, 1);
    renderSelect(gradeSel, 2);

    if (delSel) state.del = delSel.value;

    var v = currentVariant();
    var q = qty();
    var slabs = slabsFor(v);
    var stock = stockFor(v);
    var fr = freight(v, state.del);
    var soldOut = soldOutFor(v);

    /* Price the delivery choices against THIS crate, not the current pick. */
    if (delSel) {
      var o = delSel.options;
      if (o[0]) o[0].textContent = cfg.copy.deliverLabel + '   ' + (cfg.crateEconomy === 0 ? cfg.copy.freeLabel : '+' + money(cfg.crateEconomy));
      if (o[1]) o[1].textContent = cfg.copy.expressLabel + '   +' + money(freight(v, 'express') || 0);
      if (o[2]) o[2].textContent = cfg.copy.collectColLabel + ' — ' + cfg.copy.freeLabel;
      if (o[3]) o[3].textContent = cfg.copy.collectMkLabel + ' — ' + cfg.copy.freeLabel;
    }

    var priceEl = $('cp-price');
    if (priceEl) priceEl.textContent = v ? money(v.price) : cfg.copy.pricePending;

    var perEl = $('cp-perslab');
    if (perEl) {
      perEl.innerHTML = (v && slabs)
        ? money(Math.round(v.price / slabs)) + ' <span>per slab · ' + slabs + ' slabs in this crate</span>'
        : '';
    }

    /* Sold out outranks "we hold fewer than you asked for". Colour is set
       inline and reset to '' so .cp__stock's green returns — the stylesheet
       stays out of this deploy. */
    var stockEl = $('cp-stock');
    if (stockEl) {
      if (soldOut) {
        stockEl.textContent = soldOutBadge();
        stockEl.style.color = '#9a1c1c';
      } else {
        stockEl.textContent = stock === null ? ''
          : (stock >= q ? '✓ ' + stock + ' ' + (stock === 1 ? cfg.copy.crateWord : cfg.copy.cratesWord) + ' ' + cfg.copy.stockAt
            : '✗ ' + cfg.copy.stockShort);
        stockEl.style.color = '';
      }
    }

    var sayEl = $('cp-say-del');
    if (sayEl) {
      sayEl.textContent = state.del === 'collectC' ? cfg.copy.collectColDesc
        : state.del === 'collectM' ? cfg.copy.collectMkDesc
          : state.del === 'express' ? cfg.copy.expressDesc
            : cfg.copy.deliverDesc;
    }

    var linesEl = $('cp-lines');
    if (linesEl) {
      if (!v) { linesEl.innerHTML = ''; }
      else {
        var rows = [[v.options.join(' · ') + (slabs ? ' · ' + slabs + ' slabs' : ''), money(v.price * q)]];
        var delLabel = state.del === 'collectC' ? cfg.copy.collectColLine
          : state.del === 'collectM' ? cfg.copy.collectMkLine
            : state.del === 'express' ? cfg.copy.expressLine : cfg.copy.deliverLine;
        rows.push([delLabel, fr === 0 ? cfg.copy.freeLabel : money(fr)]);
        linesEl.innerHTML = rows.map(function (r) {
          return '<div class="cp__line"><span>' + r[0] + '</span><span>' + r[1] + '</span></div>';
        }).join('') + '<div class="cp__total"><span>' + cfg.copy.totalLabel + '</span><span>' + money(v.price * q + (fr || 0)) + '</span></div>';
      }
    }

    /* A sold-out crate gets no collection day and no delivery window. This was
       the actual defect on this page: the button was already disabled, but the
       most specific and most believable sentence on the screen — the date a
       customer would hold us to — kept printing directly above it. */
    var arriveEl = $('cp-arrive');
    if (arriveEl) {
      if (!v || soldOut) { arriveEl.style.display = 'none'; }
      else {
        /* Collecting from Milton Keynes means the crate is moved there first —
           the same transfer the single-slab page adds when MK has run dry. */
        var moveDays = state.del === 'collectM' ? Math.max(0, cfg.transferDays) : 0;
        var html;
        if (state.del === 'collectC') {
          html = '<b>' + cfg.copy.readyWord + ' ' + longDate(addWorkingDays(cfg.collectDays)) + '.</b><br>' + cfg.copy.bookInNote;
        } else if (state.del === 'collectM') {
          html = '<b>' + cfg.copy.readyWord + ' ' + longDate(addWorkingDays(cfg.collectDays + moveDays)) + '.</b><br>' + cfg.copy.transferNote;
        } else {
          var lo = state.del === 'express' ? cfg.expressMinDays : cfg.deliverMinDays;
          var hi = state.del === 'express' ? cfg.expressMaxDays : cfg.deliverMaxDays;
          html = '<b>' + cfg.copy.deliveredWord + ' ' + shortDate(addWorkingDays(lo)) + ' – ' + shortDate(addWorkingDays(hi)) + '.</b><br>'
            + cfg.copy.kerbsideNote;
        }
        arriveEl.innerHTML = html;
        arriveEl.style.display = 'block';
      }
    }

    var specs = $('cp-specs-body');
    if (specs && v) {
      specs.innerHTML = ''
        + '<dt>' + cfg.copy.specSize + '</dt><dd>' + v.options[0] + ' × ' + v.options[1] + '</dd>'
        + '<dt>' + cfg.copy.specGrade + '</dt><dd>' + v.options[2] + '</dd>'
        + (slabs ? '<dt>' + cfg.copy.specSlabs + '</dt><dd>' + slabs + '</dd>' : '')
        + (slabs ? '<dt>' + cfg.copy.specPerSlab + '</dt><dd>' + money(Math.round(v.price / slabs)) + '</dd>' : '')
        + '<dt>' + cfg.copy.specSku + '</dt><dd>' + (v.sku || '—') + '</dd>';
    }

    var soLine = soldOutLine();
    if (soLine) {
      soLine.textContent = soldOut ? soldOutNote() : '';
      soLine.hidden = !soldOut;
    }

    /* Precedence is load-bearing: no variant beats sold out beats short stock. */
    var ready = !!v && !soldOut && stock !== null && stock >= q;
    var btn = $('cp-atc');
    if (btn) {
      btn.disabled = !ready;
      btn.textContent = !v ? cfg.copy.atcIncomplete
        : (soldOut ? soldOutBtnLabel()
          : (ready ? cfg.copy.atcLabel : cfg.copy.atcShort));
    }
    if (v) { $('cp-vid').value = v.id; }
    $('cp-qty-hidden').value = q;

    syncUrl(v);
  }

  /* Merchant Center wants a distinct landing URL per variant with a matching
     price. replaceState so Back still leaves the page. */
  function syncUrl(v) {
    if (!v || !window.history || !history.replaceState) return;
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.get('variant') === String(v.id)) return;
      u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u.toString());
    } catch (e) { /* older browsers just keep the plain URL */ }
  }

  function applyFromUrl() {
    try {
      var want = new URL(window.location.href).searchParams.get('variant');
      if (!want) return false;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(want)) {
          if (sizeSel) sizeSel.value = variants[i].options[0];
          if (thkSel) thkSel.value = variants[i].options[1];
          if (gradeSel) gradeSel.value = variants[i].options[2];
          return true;
        }
      }
    } catch (e) { /* fall through to defaults */ }
    return false;
  }

  [sizeSel, thkSel, gradeSel, delSel, $('cp-qty')].forEach(function (el) {
    if (!el) return;
    el.addEventListener('change', render);
    el.addEventListener('input', render);
  });

  /* The disabled button is not the only way into a submit — Enter inside the
     quantity field posts the form too. Only intervene on the sold-out path so
     the native post that adds a crate to the cart is left completely alone. */
  var formEl = $('cp-form');
  if (formEl) {
    formEl.addEventListener('submit', function (e) {
      if (soldOutFor(currentVariant())) { e.preventDefault(); render(); }
    });
  }

  var thumbs = root.querySelectorAll('.cp__thumb');
  Array.prototype.forEach.call(thumbs, function (t) {
    t.addEventListener('click', function () {
      var main = $('cp-img');
      if (main && t.dataset.full) main.src = t.dataset.full;
      Array.prototype.forEach.call(thumbs, function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
    });
  });

  applyFromUrl();
  render();
})();